import { render, staticRenderFns } from "./status-prescription-charts.vue?vue&type=template&id=db49c892&scoped=true&lang=pug&"
import script from "./status-prescription-charts.vue?vue&type=script&lang=ts&"
export * from "./status-prescription-charts.vue?vue&type=script&lang=ts&"
import style0 from "./status-prescription-charts.vue?vue&type=style&index=0&id=db49c892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db49c892",
  null
  
)

export default component.exports